import { render } from "./DeleteAccount.vue?vue&type=template&id=5a34b945&scoped=true&ts=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"

import "./DeleteAccount.vue?vue&type=style&index=0&id=5a34b945&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a34b945"]])

export default __exports__